import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const CATEGORIES = [
    {
        id: "giacche",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/cdfd66d17f7dcdae_dji_mimo_20260923_135836_20260923135834_1790167090601_photo.webp",
    },
    {
        id: "hoodies",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/f43285e15548e180_dji_mimo_20260923_141330_20260923141330_1790167079700_photo.webp",
    },
    {
        id: "completi",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/b9baf50bfc9dbfd9_dji_mimo_20260923_142526_20260923142524_1790167063958_photo.webp",
    },
    {
        id: "top",
        image: "https://customer-assets-wrfwihn1.emergentagent.net/job_wear-crafted/artifacts/8ee13f9c7f385c8d_dji_mimo_20260923_140344_20260923140342_1790167087983_photo.webp",
    },
];

export default function CategoryGrid() {
    const { t } = useLanguage();
    return (
        <section className="py-24 md:py-32" data-testid="category-grid-section">
            <div className="px-5 md:px-10 mb-12 flex items-end justify-between">
                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="font-display text-4xl md:text-6xl font-bold uppercase tracking-tight"
                >
                    {t("categories.title")}
                </motion.h2>
                <motion.span
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3 }}
                    className="hidden md:block text-xs tracking-[0.3em] uppercase text-zinc-400"
                >
                    {t("categories.index")}
                </motion.span>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-[2px] bg-zinc-200">
                {CATEGORIES.map((cat, i) => (
                    <motion.div
                        key={cat.id}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: i * 0.12, duration: 0.7 }}
                    >
                        <Link
                            to={`/shop?categoria=${cat.id}`}
                            className="group relative block h-[60vh] md:h-[70vh] overflow-hidden bg-zinc-100"
                            data-testid={`category-${cat.id}`}
                        >
                            <img
                                src={cat.image}
                                alt={t(`categories.labels.${cat.id}`)}
                                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black/0 transition-colors duration-500 group-hover:bg-black/10" />
                            <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 flex items-end justify-between">
                                <span className="font-display text-2xl md:text-3xl font-bold uppercase tracking-tight text-white drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)]">
                                    {t(`categories.labels.${cat.id}`)}
                                </span>
                                <span className="flex items-center gap-2 text-white text-xs tracking-[0.25em] uppercase font-semibold opacity-0 translate-y-2 transition-all duration-500 group-hover:opacity-100 group-hover:translate-y-0 drop-shadow-[0_2px_8px_rgba(0,0,0,0.4)]">
                                    {t("categories.shop")}
                                    <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                                </span>
                            </div>
                        </Link>
                    </motion.div>
                ))}
            </div>
        </section>
    );
}
